import axios from 'axios'

const getFromCEP = async (cep) => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/address/cep/${cep}`)
  return data
}

export {
  getFromCEP
}
